export default __webpack_public_path__ + "static/media/calendar.cbabf11e.jpg";